import { CycleCheckerEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
@Entity("cycle_checker")

export class CycleChecker {

    @PrimaryGeneratedColumn("increment", { name: 'cycle_checker_id' })
    cycleCheckerId: number;

    @Column("int", {
        nullable: false,
        name: "unit_id"
    })
    unitId: number;

    @Column("decimal", {
        nullable: false,
        name: "physical_quantity",
        precision: 10, scale: 3,
        unsigned: true,
        default: 0
    })
    physicalQuantity: number;

    @Column("int", {
        nullable: false,
        name: "item_category_id"
    })
    itemCategoryId: number;

    @Column("int", {
        nullable: true,
        name: "item_sub_category_id"
    })
    itemSubCategoryId: number;

    @Column("int", {
        nullable: false,
        name: "master_brand_id"
      })
      masterBrandId: number;
      
    @Column("int", {
        nullable: false,
        name: "item_id"
    })
    itemId: number;

    @Column("int", {
        nullable: true,
        name: "saleorder_id"
    })
    saleOrderId: number;

    @Column({
        type:"enum",
        enum:CycleCheckerEnum,
        nullable: false,
        default: CycleCheckerEnum.NOT_APPROVED,
        name: "status"
    })
    status: CycleCheckerEnum

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        default: 'Admin',
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column("int", {
        nullable: true,
        name: "location"
    })
    locationId: number 

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "reason"
    })
    reason: string

    @Column("decimal", {
        nullable: false,
        name: "previous_quantity",
        precision: 10, scale: 3,
        unsigned: true,
        default: 0
    })
    previousQuantity: number;
}
